document.addEventListener('DOMContentLoaded', function() {
  const currentPST = document.getElementById('currentPST');
  const convertButton = document.getElementById('convert-button');
  const convertedTime = document.getElementById('convertedTime');

  // Define an array of holiday dates and corresponding tooltips
  const holidays = [
    { date: '2023-12-25', tooltip: 'Christmas Day' },
    { date: '2023-11-11', tooltip: 'Veterans Day' },
    // Add more holiday objects as needed
  ];

  // Initialize the Flatpickr date picker with custom format, 12hr time, and restricted holidays
  const userTimePicker = flatpickr('#userTime', {
    enableTime: true,
    dateFormat: 'm/d/Y h:i K',
    time_24hr: false,
    disable: [
      function(date) {
        // Disable weekends (Saturday and Sunday)
        if (date.getDay() === 0 || date.getDay() === 6) {
          return true;
        }
        
        // Check if the date is a holiday
        const dateString = date.toISOString().split('T')[0]; // Convert date to 'YYYY-MM-DD' format
        return holidays.some(holiday => holiday.date === dateString);
      }
    ],
    onDayCreate: function(dObj, dStr, fp, dayElem) {
      // Add tooltips to disabled dates
      const date = new Date(dStr);
      const holiday = holidays.find(holiday => holiday.date === dStr);
      if (holiday) {
        dayElem.title = holiday.tooltip;
      }
    }
  });

  function updateCurrentPST() {
    const now = new Date();
    const pstTime = now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
    currentPST.textContent = pstTime;
  }

  setInterval(updateCurrentPST, 1000);

  // Convert user-entered time to PST
  convertButton.addEventListener('click', function() {
    const userTime = userTimePicker.selectedDates[0]; // Retrieve selected date from Flatpickr instance
    const userTimezone = document.getElementById('userTimezone').value;

    const userTimeOptions = { timeZone: userTimezone };
    const userTimeInUTC = userTime.toLocaleString('en-US', userTimeOptions);

    const convertedOptions = { timeZone: 'America/Los_Angeles' };
    const convertedTimeInPST = new Date(userTimeInUTC).toLocaleString('en-US', convertedOptions);

    convertedTime.innerHTML = `<p id="converted-time">Place This Time in The Red Box:</p> ${convertedTimeInPST}`;
  });
});